
import { Message } from '../models';

const TIME_FOR_PASTING_MESSAGES_INTO_GROUP = 60e3;

const calculateGroupParams = (messages: Message[], indexModifiedMessage: number): Message[] => {
  /* для предыдущего сообщения */
  if (messages[indexModifiedMessage - 1]) {
    messages[indexModifiedMessage - 1].isLastInGroup = calculateIsLast(messages[indexModifiedMessage - 1], messages[indexModifiedMessage])
  }

  /* для текущего сообщения */
  messages[indexModifiedMessage].isFirstInGroup = calculateIsFirst(messages[indexModifiedMessage], messages[indexModifiedMessage - 1])
  messages[indexModifiedMessage].isLastInGroup = calculateIsLast(messages[indexModifiedMessage], messages[indexModifiedMessage + 1])

  /* для следующего сообщения */
  if (messages[indexModifiedMessage + 1]) {
    messages[indexModifiedMessage + 1].isFirstInGroup = calculateIsFirst(messages[indexModifiedMessage + 1], messages[indexModifiedMessage - 1])
  }

  return messages
}

const parseDate = (dateStr?: string): number => dateStr ? Date.parse(dateStr) : 0;

const calculateIsLast = (message: Message, nextMessage: Message | undefined): boolean => {
  if (!nextMessage || !nextMessage.id) return true;
  if (message.nickname !== nextMessage.nickname) return true;
  return parseDate(nextMessage.date) - parseDate(message.date) > TIME_FOR_PASTING_MESSAGES_INTO_GROUP;
};

const calculateIsFirst = (message: Message, prevMessage: Message | undefined): boolean => {
  if (!prevMessage || !prevMessage.id) return true;
  if (message.nickname !== prevMessage.nickname) return true;
  return parseDate(message.date) - parseDate(prevMessage.date) > TIME_FOR_PASTING_MESSAGES_INTO_GROUP;
}

export default calculateGroupParams
